(() => {
  const article = document.querySelector('.articles__content');
  if (!article) return;

  const headings = [...article.querySelectorAll('h2, h3')].filter(
    (heading) => heading.textContent.trim().length > 0
  );
  if (headings.length < 3) return;

  const usedIds = new Set([...document.querySelectorAll('[id]')].map((node) => node.id));
  const slug = (value) =>
    value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 72) || 'section';

  headings.forEach((heading, index) => {
    if (heading.id) return;
    const base = `guide-${slug(heading.textContent)}`;
    let candidate = base;
    let suffix = 2;
    while (usedIds.has(candidate)) {
      candidate = `${base}-${suffix}`;
      suffix += 1;
    }
    heading.id = candidate;
    usedIds.add(candidate);
  });

  const nav = document.createElement('nav');
  nav.className = 'ihf-article-toc';
  nav.setAttribute('aria-labelledby', 'ihf-article-toc-title');

  const title = document.createElement('h2');
  title.id = 'ihf-article-toc-title';
  title.textContent = 'On this page';
  nav.append(title);

  const list = document.createElement('ol');
  headings.forEach((heading) => {
    const item = document.createElement('li');
    if (heading.tagName === 'H3') item.className = 'ihf-article-toc__subitem';
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  nav.append(list);
  article.before(nav);
})();
